export default "__VITE_ASSET__bhaS52DZ__"